import { useQuery } from '@percent/grants-nomination-form/hooks';
import { getCountriesAction } from '@percent/grants-nomination-form/api/countries/countries.actions';
import { CountriesContext } from './CountriesContext';
import { PropsWithChildren, useMemo } from 'react';

export function CountriesContextController({ children }: PropsWithChildren) {
  const { data: countries } = useQuery(['countries'], getCountriesAction);

  const contextValue = useMemo(() => countries?.data ?? [], [countries]);

  return <CountriesContext.Provider value={contextValue}>{children}</CountriesContext.Provider>;
}
